import styles from "./Introduction.module.css"

export const Introduction = () => {
    return <div id="Home" className={styles.introduction_container}>
        <div className={styles.introduction_inside_container}>
            <div>
                <p>Scroll for more content</p>
            </div>

            <div className={styles.selfIntro}>
                <div>
                    <p>Hello! <br />I’m Pratik Jadhav</p>
                    <p>A Full Stack Web Developer</p>
                    <p>Write code that’s self explanatory, easy to maintain, easily understandable and Optimised.
                        Possess a good set of problem solving skills. Willing to adapt. Design applications in a way that best serves the users.
                        Aim for success.
                    </p>
                    <div>
                        <a href="https://www.linkedin.com/in/pratik-r-jadhav-70407b208/" className={styles.hover_underline_animation} target="_blank" rel="noreferrer">LinkedIn</a>
                        <a href="https://github.com/pratikjadhav080" className={styles.hover_underline_animation} target="_blank" rel="noreferrer">Github</a>
                        <a href="https://medium.com/@pratikjadhav080" className={styles.hover_underline_animation} target="_blank" rel="noreferrer">Medium</a>
                    </div>
                </div>
            </div>

            <div>
                <img src="./Pratik_BNW.png" alt="MyImage"></img>
            </div>
        </div>


    </div>
}
